import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import infoIconlabel from 'src/assets/InfoModalIcon.svg';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
    height: '254px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '0.9rem',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '0.9rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '400px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
});

class InformationDialog extends React.Component {
  static propTypes = {};
  render() {
    const { children, classes, open, onCancel, title } = this.props;

    return (
      <Dialog classes={{ root: classes.root, paper: classes.rootPaper }} open={open}>
        <div className={classes.header}>
          <h2 className={classes.title} id="confirm-title">
            <img alt="info" src={infoIconlabel} /> {title}
          </h2>
          <div className={classes.closeIcon} onClick={onCancel || null}>
            <CloseIcon />
          </div>
        </div>
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(InformationDialog);
